import type { FaireProductEntity } from "../../entity_types/product";

export const p_pdyqc7yez2: FaireProductEntity = {
  token: "p_pdyqc7yez2",
  type: "product",
  name: "Starlings Condolence Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/cd0d98fc9c48d59bc2e5b4b6856ca0220cbaace581effd02811ffd32939883c6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/92589ae38f488bb5f4206a011ae4dafd51adde6418174238cce04d74d6b0a885.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:27.823Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
